<template lang="pug">
div(style="margin:0 10px;")
  template(v-if="list.length")
    .flowList(v-for="(item,index) in list" :key="index"  @click="lookClick(item)")
      .header_style
        .header_title {{ flowTitle(item) || '--'}}
        .header_status(:class="`type${item.status}`") {{ statusName(item.status) || '--'}}
      .main_style
        .main_li
          span.main_title 流程标题
          span.main_info.info_title {{ item.title || '--' }}
        .main_li
          span.main_title 申请时间
          span.main_info {{ item.flowInstanceStartTime || '--' }}
        .main_li(v-if="item.currentNodeAssigneeName")
          span.main_title 当前审批人
          span.main_info {{ item.currentNodeAssigneeName || '--' }}
  .empty-data(v-else)
    van-empty(description="暂无数据")
</template>
<script>
import { getStatusName } from "@/CommonDP/components/processComponents/config";
export default {
  name: '',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      statusName: getStatusName
    };
  },
  methods: {
    lookClick(row) {
      this.$emit('onClick', row);
    },
    // 流程展示的标题
    flowTitle(item) {
      return item?.flowInstanceOwnerName + "发起的" + (item?.businessName || "流程");
    }
  }
};
</script>
<style lang="scss" scoped>
.flowList{
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 5px;
  padding:0 10px;
}
.header_style{
  width: 100%;
  height:40px;
  line-height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px dashed #E7E7E7;
  .header_title{
    flex: 1;
    font-weight: 400;
    font-size: 14px;
    color:#000;
    overflow: auto;
    white-space: nowrap;
  }
  .header_status{
    height: 26px;
    line-height: 26px;
    border-radius: 16px;
    text-align: center;
    padding: 0 10px;
    font-weight: 400;
    font-size: 12px;
    margin-left: auto;
  }
}
.main_style{
  .main_li{
    line-height: 24px;
    font-size:12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .main_title{
      color: rgba(102, 102, 102, 0.90);
    }
    .main_info{
      max-width: calc(100% - 60px);
      text-align: right;
    }
    .info_title{
      text-align: left;
    }
  }
}
.empty-data{
  height:calc(100vh - 100px);
  text-align: center;
  padding:50px 0;
  font-size: 16px;
  background: #fff;
}
::v-deep .van-cell{
  padding:0;
  height: 24px;
  line-height: 24px;

  .van-cell__title{
    max-width: 100px;
  }
  .van-cell__value{
    overflow-x: auto;
  }
}

.type1,.type4{
  border: 1px solid #10A667;
  background: rgba(16, 166, 103, 0.10);
  color: #10A667;
}

.type2 {
  border: 1px solid #FF7A00;
  background: rgba(255, 122, 0, 0.10);
  color: #FF7A00;
}

.type3 {
  border: 1px solid #60656B;
  background: rgba(96, 101, 107, 0.10);
  color: #60656B;
}

.type8 {
  border: 1px solid #9746E8;
  background: rgba(151, 70, 232, 0.10);
  color: #9746E8;
}

.type9 {
  border: 1px solid #2F8BF8;
  background: rgba(47, 139, 248, 0.10);
  color: #2F8BF8
}

.type0 {
  border: 1px solid #FF4A4A;
  background: rgba(255, 74, 74, 0.10);
  color: #FF4A4A;
}

::-webkit-scrollbar {
  display: none;
}
</style>
